import React, { useEffect, useRef } from 'react';
import './testimonials.css';
import firstladie from '../../assets/firstladie.jpg';
import fourthladie from '../../assets/fourthladie.jpg';
import firstgen from '../../assets/firstgen.jpg';
import secondgen from '../../assets/secondgen.jpg';
import thirdgen from '../../assets/thirdgen.jpg';
import fourthgen from '../../assets/fourthgen.jpg';

// Import Swiper
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const testimonials = [
  {
    id: 1,
    name: 'Aino Kinjo',
    role: 'Photographer',
    image: firstladie,
    quote: "I'm excited about my new portfolio website by IPM! A big thank you to Professor01 and the IPM team for bringing my vision to life.",
    rating: 5
  },
  {
    id: 2,
    name: 'Carolos',
    role: 'Shopkeeper',
    image: firstgen,
    quote: "Thanks to IPM, my eCommerce website is now optimized for SEO, which helps me sell more boards than ever before. The sleek design is just the icing on the cake 😀",
    rating: 5
  },
  {
    id: 3,
    name: 'Ekow Boateng',
    role: 'Business Man',
    image: secondgen,
    quote: "Big shoutout to the IPM team for turning my furniture shop into an online success!",
    rating: 5
  },
  {
    id: 4,
    name: 'Charles',
    role: 'Music Specialist',
    image: thirdgen,
    quote: "Thanks to Professor01, my guitar shop website is a hit! Quick, personal, and effective—couldn't be more fun 👍",
    rating: 5
  },
  {
    id: 5,
    name: 'Milena',
    role: 'Editor',
    image: fourthladie,
    quote: "Thanks to IPM, my portfolio website now showcases my editing skills and helps me secure jobs with top YouTubers.",
    rating: 5
  },
  {
    id: 6,
    name: 'Kevin',
    role: 'Hairdresser',
    image: fourthgen,
    quote: "I'm so excited about my new website that showcases my hair skills! Thanks to IPM for making that possible 😅",
    rating: 5
  }
];

const Testimonials = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials" id="review" ref={sectionRef}>
      <div className="testimonials__container">
        {/* Header */}
        <div className="testimonials__header">
          <span className="testimonials__badge">Testimonials</span>
          <h2 className="testimonials__title">
            Client <span className="gradient-text">Reviews</span>
          </h2>
          <div className="testimonials__underline"></div>
          <p className="testimonials__subtitle">
            What my clients say about working with me
          </p>
        </div>

        {/* Slider */}
        <div className="testimonials__slider-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={false}
            loop={true}
            grabCursor={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              }
            }}
            className="testimonials__swiper"
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <div className="testimonial-card">
                  {/* Top Section */}
                  <div className="testimonial-card__top">
                    {/* Rating Stars */}
                    <div className="testimonial-card__rating">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="star">★</span>
                      ))}
                    </div>
                    
                    {/* Quote Icon */}
                    <div className="testimonial-card__quote-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <path d="M10 11H6C6 8.79086 7.79086 7 10 7V11ZM10 11V17H6V11H10ZM14 7C11.7909 7 10 8.79086 10 11V17H14V7ZM14 7V11H18V7H14Z" fill="#6366f1" opacity="0.15"/>
                        <path d="M10 11H6V7H10V11ZM10 11V17H6V11H10ZM14 7H18V11H14V7ZM14 7V11H18V7H14Z" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </div>
                  </div>

                  {/* Quote */}
                  <p className="testimonial-card__quote">"{testimonial.quote}"</p>

                  {/* Author */}
                  <div className="testimonial-card__author">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="testimonial-card__avatar"
                    />
                    <div className="testimonial-card__author-info">
                      <h4 className="testimonial-card__name">{testimonial.name}</h4>
                      <span className="testimonial-card__role">{testimonial.role}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Trust Indicators */}
        <div className="testimonials__trust">
          <div className="trust-item">
            <span className="trust-number">50+</span>
            <span className="trust-label">Happy Clients</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <span className="trust-number">4.9</span>
            <span className="trust-label">Average Rating</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <span className="trust-number">100%</span>
            <span className="trust-label">Satisfaction Rate</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;